import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useChaptersQuizzes(data = {}) {
  const { enabled = false, configs = {}, courseID } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getChapters() {
    return privateFetch
      .get(`/v1/admin/course/${courseID}/chapters/quizzes`, configs)
      .then((res) => res.data);
  }

  return useQuery(['chapters-quizzes', { data }], getChapters, { enabled });
}

export default useChaptersQuizzes;
